<div class="global-search-item" [ngClass]="isEnhancedGlobalSearchEnabled ? 'enhanced-global-search' : ''">
  <div *ngIf="isEnhancedGlobalSearchEnabled" class="d-block">
    <div class="row ui-g-12 m-0">
      <div class="ui-g-4 p-0 font-secondary pl-2 pr-2">
        <i class="font-14 fas fa-user pr-2 icon-label"></i>
        <span class="font-16 font-700" style="color: #3D4242;">Customers</span>

        <div (scroll)="onCustomerScroll($event)" class="scroller h-450 mt-2" style="border-right: lightgray solid 1px;
        overflow-y: auto;">
          <div *ngIf="customers && customers.length; else noCustomerResults" class="mt-1 py-2 font-12 text-center">
            <ng-container *ngFor="let customer of customers">
              <div class="mb-2 mr-2 card-gs">
                <div class="text-left font-600 font-12 truncate title" (click)="openSidePanel(customer, 'customer')"
                  [innerHTML]="(customer.customer?.fullName || customer.customer?.fullNameQBO) | highlighter:query:'partial'">
                </div>
                <div *ngIf="customer.customer?.mobileInfo && customer.customer?.mobileInfo.length">
                  <div class="d-flex" *ngFor="let phone of customer.customer?.mobileInfo">
                    <i class="fal fa-phone-alt pl-1p font-12 align-self-center">{{customer.customer?.mobileInfo.length >
                      1 && phone.isPrimary ? '*' : ''}}</i>
                    <span class="font-12"
                      [ngClass]="customer.customer?.mobileInfo.length > 1 && phone.isPrimary ? 'pl-2p' : 'pl-2'"
                      [innerHTML]="fomratValues(phone.value, 'phone') | highlighter:query:'partial'"></span>
                  </div>
                </div>
                <div *ngIf="customer.customer?.emailInfo && customer.customer?.emailInfo.length">
                  <div class="d-flex truncate" *ngFor="let email of customer.customer?.emailInfo">
                    <i class="fal fa-envelope pl-1p font-12 align-self-center"></i>
                    <span class="font-12 pl-2 truncate" [innerHTML]="email.value | highlighter:query:'partial'"></span>
                  </div>
                </div>
                <div *ngIf="customer?.customer?.appointments?.length === 1">
                  <div class="d-flex truncate open-link-container appt-color"
                    *ngFor="let appt of customer?.customer?.appointments" (click)="openAppointmentModal(appt)">
                    <i class="fal fa-calendar-alt pl-1p font-12 align-self-center"></i>
                    <span class="font-12 pl-2 hover-underline pointer text-truncate" [innerHTML]="appt?.startDateTime">
                    </span>
                    <i class="open-link-icon pl-2 align-self-center fal fa-external-link-alt pointer"
                      (click)="openInExsistingTab()"></i>
                  </div>
                </div>

                <div *ngIf="customer?.customer?.appointments?.length >= 2">
                  <div class="d-flex truncate open-link-container appt-color"
                    (click)="openSidePanel(customer, 'customer')">
                    <i class="fal fa-calendar-alt pl-1p font-12 align-self-center"></i>
                    <span class="font-12 pl-2 hover-underline pointer text-truncate">
                      Show {{customer.customer.appointments.length}} appointments
                    </span>
                    <i class="open-link-icon pl-2 align-self-center fal fa-external-link-alt pointer"
                      (click)="openInExsistingTab()"></i>
                  </div>
                </div>

                <!-- ------- driver details --------  -->
                <div *ngIf="customer?.customer?.drivers?.length
                && isMyFleetCenterEnabled && customer?.customer?.isFleetCustomer">
                  <ng-container *ngFor="let driver of customer?.customer?.drivers">
                    <div class="d-flex truncate open-link-container driver-color"
                      (click)="openSidePanel({ customer, driverId: driver.driverId }, 'driver')">
                      <i class="fal fa-steering-wheel pl-1p font-12 align-self-center"></i>
                      <span class="font-12 pl-2 hover-underline pointer text-truncate">
                        Driver: <span class="truncate"
                          [innerHTML]="driver.driverName | highlighter:query:'partial'"></span>
                      </span>
                      <i class="open-link-icon d-inline  pl-2 align-self-center fal fa-external-link-alt pointer"></i>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="isCustomerLoading" class="text-center p-3">
            <div class="fad fa-spinner-third rotate font-15"></div>
            <div class="font-12">Loading</div>
          </div>
          <ng-template #noCustomerResults>
            <div *ngIf="!isCustomerLoading" class="body mt-3 mr-3 py-2 font-12 text-center">
              <i class="fal fa-empty-set align-self-center"></i>
              <span class="pl-2 font-12 align-self-center">No results found</span>
            </div>
          </ng-template>
        </div>

      </div>

      <div class="ui-g-4 p-0 font-secondary pr-2 pl-1">
        <i class="font-14 fas fa-car pr-2 icon-label"></i>
        <span class="font-16 font-700" style="color: #3D4242;">Vehicles</span>
        <!-- [ngClass]="customers.length > 4 || vehicles.length > 4 || orders.length > 4 ? 'h-450' ?
          customers.length < 4 || vehicles.length < 4 || orders.length < 4 ? 'h-250' : 'h-150'" -->
        <div (scroll)="onVehicleScroll($event)" class="scroller h-450 mt-2" style="border-right: lightgray solid 1px;
        overflow-y: auto;">
          <div *ngIf="vehicles && vehicles.length; else noVehicleResults" class="mt-1 py-2 font-12 text-center">
            <ng-container *ngFor="let vehicle of vehicles">
              <div class="mb-2 mr-2 card-gs" (click)="openSidePanel(vehicle, 'vehicle')">
                <div class="text-left font-600 font-12 truncate title" style="color: #3D4242;"
                  [innerHTML]="vehicle.vehicle?.vehicleName | highlighter:query:'partial'">
                </div>
                <div class="d-flex" *ngIf="vehicle.customer?.fullName">
                  <i class="fal fa-user font-12 align-self-center"></i>
                  <span class="font-12 pl-2"
                    [innerHTML]="vehicle.customer?.fullName | highlighter:query:'partial'"></span>
                </div>
                <div class="d-flex" *ngIf="vehicle.vehicle?.licensePlateNo">
                  <i class="fal fa-digital-tachograph font-12 align-self-center"></i>
                  <span class="font-12 pl-2"
                    [innerHTML]="vehicle.vehicle?.licensePlateNo | highlighter:query:'partial'"></span>
                </div>
                <div class="d-flex" *ngIf="vehicle.vehicle?.VIN">
                  <i class="fal fa-barcode-read font-12 align-self-center"></i>
                  <span class="font-12 pl-2" [innerHTML]="vehicle.vehicle?.VIN | highlighter:query:'partial'"></span>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="isVehicleLoading" class="text-center p-3">
            <div class="fad fa-spinner-third rotate font-15"></div>
            <div class="font-12">Loading</div>
          </div>
          <ng-template #noVehicleResults>
            <div *ngIf="!isVehicleLoading" class="body mt-3 mr-3 py-2 font-12 text-center">
              <i class="fal fa-empty-set align-self-center"></i>
              <span class="pl-2 font-12 align-self-center">No results found</span>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="ui-g-4 p-0 font-secondary pl-2 pr-2">
        <div class="d-flex flex-between-center">
          <div class="d-flex">
            <i class="align-self-center font-14 fas fa-file-alt pr-2 icon-label"></i>
            <span class="font-16 font-700" style="color: #3D4242;">Repair Orders</span>
          </div>
          <span (click)="closeModal()">
            <i class="fal fa-times pointer"></i>
          </span>
        </div>

        <div (scroll)="onOrdersScroll($event)" class="scroller h-450 mt-2"
          [ngClass]="customers.length > 4 || vehicles.length > 4 || orders.length > 4 ? 'h-450' : ''"
          style="overflow-y: auto;">
          <div *ngIf="orders && orders.length; else noOrderResults" class="mt-1 py-2 font-12 text-center">
            <ng-container *ngFor="let order of orders">
              <div (click)="openEstimate(order.order, $event)" class="mb-2 mr-2 card-gs">
                <div class="d-flex text-left font-600 font-12">
                  <span class="truncate title" style="color: #3D4242; max-width: 175px;"
                    [innerHTML]="'RO# ' + order.order?.code + ': ' + order.order?.title | highlighter:query:'partial'">
                  </span>
                  <div class="flex-start-center priority-tag-wrapper ml-1"
                    *ngIf="isROPrioritiesEnabled && (order.order?.priority?.priorityId)">
                    <span class="color-rect-priority" [style.backgroundColor]="order.order?.priority?.color"></span>
                    <span class="pl-1 text-truncate font-8" style="max-width: 50px;"
                      [pTooltip]="order.order?.priority?.name" tooltipPosition="top"
                      [style.color]="order.order?.priority?.color"
                      [innerHTML]="order.order?.priority?.name | highlighter:query:'partial'"></span>
                  </div>
                </div>

                <div class="d-flex truncate" *ngIf="order.order?.orderStatus === 'invoice'">
                  <div class="order-color-enhanced-gs align-self-center"
                    [ngStyle]="{backgroundColor: 'var(--primary-500)'}">
                  </div>
                  <span class="pl-1 font-12 truncate"
                    [innerHTML]="'Inv# ' + order.order?.invCode + ' - ' | highlighter:query:'partial'">
                  </span>
                  <span class="font-12"
                    [innerHTML]="fomratValues(order.order?.total?.grand, 'invoiceTotal') | highlighter:query:'partial'">
                  </span>
                </div>
                <div class="d-flex truncate" *ngIf="order.vehicle?.name">
                  <i class="fal fa-car font-12 align-self-center"></i>
                  <span class="font-12 pl-2" [innerHTML]="order.vehicle?.name | highlighter:query:'partial'"></span>
                </div>
                <div class="d-flex truncate" *ngIf="order.customer?.fullName">
                  <i class="fal fa-user font-12 align-self-center"></i>
                  <span class="font-12 pl-2"
                    [innerHTML]="order.customer?.fullName | highlighter:query:'partial'"></span>
                </div>
              </div>
            </ng-container>
          </div>
          <div *ngIf="isOrderLoading" class="text-center p-3">
            <div class="fad fa-spinner-third rotate font-15"></div>
            <div class="font-12">Loading</div>
          </div>
          <ng-template #noOrderResults>
            <div *ngIf="!isOrderLoading" class="body mt-3 py-2 font-12 text-center">
              <i class="fal fa-empty-set align-self-center"></i>
              <span class="pl-2 font-12 align-self-center">No results found</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="footer pl-3 ui-g-12 py-1" style="font-size: 12px;background: var(--secondary-25);">
      <app-switch-pill id="create-update-workboard-number" position="end" label="Show archived orders" [fontSize]="12"
        [isActive]="globalSearchIncludeArchivedOrders" (appChange)="handleChange($event)">
      </app-switch-pill>
    </div>
  </div>

  <div *ngIf="!isEnhancedGlobalSearchEnabled" class="row m-0">
    <!-- Start Customer Section -->
    <div class="col p-0 primary-hover"
      [ngClass]="{'col-5': data?.vehicles?.length > 0 || data?.appointments?.length > 0 || data?.orders?.length > 0}"
      (click)="openCustomerPanel($event)">
      <div class="search-global-list-wrapper">
        <div class="p-2 search-global-icon {{data.isFleetCustomer? 'fleet-icon' : ''}}">
          <i class="font-gray font-14 {{data?.isFleetCustomer? 'fal fa-cars' : 'fal fa-user'}}"></i>
        </div>

        <div class="font-11 search-global-content">
          <div [innerHTML]="renderText(data?.fullNameQBO, 'capitalize')" class="font-12 text-truncate"></div>
          <div>
            <div *ngIf="data?.companyName" class="font-gray font-11 text-truncate font-bold"
              [innerHTML]="renderText(data?.companyName, 'companyName')"></div>
            <div *ngIf="data?.email" class="font-gray font-11 text-truncate"
              [innerHTML]="renderText(data?.email, 'email')"></div>
            <div *ngIf="data?.phone" class="font-gray font-11" [innerHTML]="renderText(data?.phone, 'phone')"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Customer Section <-->

    <div class="col-7 p-0"
      *ngIf="data?.vehicles?.length > 0 || data?.appointments?.length > 0 || data?.orders?.length > 0">
      <!-- Start Vehicle Section -->
      <div *ngFor="let vehicle of data?.vehicles" class="mb-2 primary-hover search-global-list-wrapper"
        (click)="openVehiclePanel($event, vehicle)">
        <div class="p-2 search-global-icon">
          <i class="fal fa-car font-gray"></i>
        </div>
        <div class="search-global-content">
          <div class="font-11 text-truncate" tooltipStyleClass="list-tooltip"
            [pTooltip]="vehicle?.vehicleName? vehicle?.vehicleName : vehicle?.name" [escape]="false"
            tooltipPosition="top" [innerHTML]="renderText( vehicle?.vehicleName? vehicle?.vehicleName : vehicle?.name)">
          </div>
          <div [hidden]="!vehicle?.licensePlateNo" class="font-11 font-gray">
            Plate number: <span [innerHTML]="renderText(vehicle?.licensePlateNo)"></span>
          </div>
        </div>
      </div>
      <!-- End Vehicle Section -->

      <!-- Start Appt Section -->
      <div *ngFor="let appointment of data?.appointments" class="ui-g-12 p-0 mb-2 primary-hover"
        (click)="editAppointment(appointment.appointmentId, $event)">
        <div class="search-global-list-wrapper">
          <div class="search-global-icon p-2">
            <i class="fal fa-calendar-alt font-gray"></i>

          </div>
          <div class="search-global-content">
            <div class="font-11">
              {{helperService.getDate(appointment?.start)}}&nbsp;
              {{helperService.getTime(appointment?.start)}}
            </div>
            <div class="font-11 font-gray text-truncate" [innerHTML]="renderText(appointment?.title,'capitalize')">
              {{appointment?.title || defaultTitle}}</div>
          </div>
        </div>
      </div>
      <!-- End Appt Section -->

      <!-- Start Order Section -->
      <div *ngFor="let order of data?.orders" class="ui-g-12 p-0 mb-2 primary-hover"
        (click)="openEstimate(order, $event)">
        <div class="search-global-list-wrapper">
          <div class="search-global-icon p-2">
            <i class="fal fa-file-alt font-gray"></i>

          </div>
          <div class="search-global-content"
            [ngClass]="{'mr-1 search-global-with-order-status': order?.orderStatus === 'invoice' || order?.orderStatus === 'estimate'}">

            <div class="flex-start-center">
              <div class="font-11 text-truncate"
                [innerHTML]="renderText('Order '  + order?.code + ' ' + (order?.title || defaultTitle))">
              </div>
              <div class="flex-start-center priority-tag-wrapper ml-1"
                *ngIf="isROPrioritiesEnabled && (order?.priority?.priorityId || defaultPriority?._id)">
                <span class="color-rect-priority"
                  [style.backgroundColor]="order?.priority?.color || defaultPriority?.color"></span>
                <span class="pl-1 text-truncate" style="max-width: 50px;" [pTooltip]="order?.priority?.name ||
                  defaultPriority?.name" tooltipPosition="top"
                  [style.color]="order?.priority?.color">{{order?.priority?.name ||
                  defaultPriority?.name}}</span>
              </div>
            </div>


            <div class="font-11 font-gray flex-start-center">
              <div class="order-color mr-1"
                [ngStyle]="{backgroundColor: order?.orderStatus === 'invoice'? 'var(--primary-500)': 'var(--warning-700)'}">
              </div>

              <span *ngIf="order?.orderStatus !== 'invoice'" class="flex-start-center">
                <span class="capitalize">{{order?.orderStatus}}</span>&nbsp;-&nbsp;{{(order?.total?.grand | currency:
                usd)}}
              </span>

              <div *ngIf="order?.orderStatus === 'invoice'" class="font-11"
                [innerHTML]="renderText('Invoice #'  + order?.invCode + ' - ' + (order.total.grand ? '$'+order.total.grand : 0))">
              </div>
              <span *ngIf="order.isArchived">&nbsp;(Archived)</span>
            </div>
          </div>
        </div>
      </div>
      <!-- End Order Section -->

    </div>
  </div>
</div>
